// removed by extract-text-webpack-plugin
module.exports = {"register-business-box":"register-business-box","register-box-body":"register-box-body","section-heading":"section-heading","Select":"Select"};


//////////////////
// WEBPACK FOOTER
// ./components/business/register-business-form/_RegisterBusinessForm.scss
// module id = ./components/business/register-business-form/_RegisterBusinessForm.scss
// module chunks = 0